import { CLAVES_COMENTARIO_OBLIGATORIO } from "../constants/productoSeleccionado.constants";
import type {
    DetalleProducto,
    FilaProductoSeleccionado,
} from "../types/productoSeleccionado.types";

const FORMATO_MONEDA: Intl.NumberFormatOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
};

export const requiereComentario = (clave?: string): boolean =>
    Boolean(clave) && CLAVES_COMENTARIO_OBLIGATORIO.includes(clave!.trim().toUpperCase());

export const faltaComentario = (detalle: { clave: string; observaciones?: string }): boolean =>
    requiereComentario(detalle.clave) && !detalle.observaciones?.trim();

export const formatearMoneda = (valor: number): string =>
    `$${(Number.isFinite(valor) ? valor : 0).toLocaleString("es-MX", FORMATO_MONEDA)}`;

export const crearIdLinea = (): string =>
    typeof crypto !== "undefined" && "randomUUID" in crypto
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const esCantidadValida = (cantidad: number | "" | null | undefined): cantidad is number =>
    typeof cantidad === "number" && Number.isFinite(cantidad) && cantidad > 0;

export const obtenerIdProducto = (producto: {
    id?: string | number;
    id_inventario?: string | number;
}): string => String(producto.id ?? producto.id_inventario ?? "");

export const resumirProductoEnDetalles = (
    detalles: DetalleProducto[],
    producto: { id?: string | number; id_inventario?: string | number }
): { lineas: number; cantidadTotal: number } => {
    const id = obtenerIdProducto(producto);
    const delProducto = detalles.filter((d) => String(d.id_inventario) === id);
    return {
        lineas: delProducto.length,
        cantidadTotal: delProducto.reduce((suma, d) => suma + d.cantidad, 0),
    };
};

export const calcularTotalPedido = (detalles: DetalleProducto[]): number =>
    detalles.reduce((suma, detalle) => suma + (Number(detalle.precio_total) || 0), 0);

export const crearFilaTotal = (totalPedido: number): FilaProductoSeleccionado => ({
    id_linea: "__total__",
    clave: "",
    nombre: "",
    tipo_producto: "",
    precio_unitario: 0,
    cantidad: 0,
    precio_total: totalPedido,
    esTotal: true,
});